import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import InstitutionalPage from "../components/institutional/InstitutionalPage";
import { institutionalPages } from "../data/institutionalPages";

function Institutional() {
  const { pathname } = useLocation();
  const page = institutionalPages[pathname];

  if (!page) {
    return <Navigate to="/" replace />;
  }

  return <InstitutionalPage {...page} />;
}

export default Institutional;
